export default __webpack_public_path__ + "static/media/bca.4166cfdb.svg";